import * as angular from "angular";
import {IController} from "angular";
import {PlanningCommonService} from "../../services/planning-coomon-service.service";

export class PlanningActivityPackagesOverviewComponent implements IController {
  activity: any;
  route: any;
  onClose: Function;

  private weightUnit: any;
  private routeColor: any;

  constructor(private splitService, private planningCommonService: PlanningCommonService) {
  }

  $onInit() {
    this.routeColor = this.planningCommonService.getRouteColor(this.route);
    this.weightUnit = this.splitService.getWeightUnit();
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningActivityPackagesOverview', {
    bindings: {
      activity: '<',
      route: '<',
      onClose: '&'
    },
    template: require('./planning-activity-packages-overview.html').default,
    controller: PlanningActivityPackagesOverviewComponent
  });

